<script setup lang="ts">
const { t } = useI18n();
</script>

<template>
  <i18n-t tag="div" keypath="pages.auth_sign_in.auth_terms" class="text-xs text-secondary">
    <template #terms_of_service>
      <BaseButton name="terms-of-service" tag="nuxt-link" type="secondary" to="/info/terms_of_service" target="_blank" class="underline" link>
        {{ t('labels.footer_links.terms_of_service') }}
      </BaseButton>
    </template>
    <template #privacy_policy>
      <BaseButton name="privacy-policy" tag="nuxt-link" type="secondary" to="/info/privacy_policy" target="_blank" class="underline" link>
        {{ t('labels.policy') }}
      </BaseButton>
    </template>
  </i18n-t>
</template>
